<div class="container-fluid px-4 mt-4 mb-5" *ngIf="facilityId>0;else noId">
    <div class="row">
        <div class="col-xl-12">
            <div class="card h-100">
                <div class="card-header">
                    <!-- toolbar -->

          <!-- toolbar -->
        <div class="shadow-lg border">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Rango del calendario</mat-label>
                            <mat-date-range-input [rangePicker]="picker" [formGroup]="form">
                                <input matStartDate placeholder="Desde" formControlName="start">
                                <input matEndDate placeholder="Hasta" formControlName="end"
                                    (dateChange)="setRangeCalendar()">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 pt-3">
                        <div class="btn-group shadow-lg" style="border-radius: 10px;">
                            <button class="btn" (click)="cambiarMes(-1)">
                                <i class="fas fa-chevron-left"></i>
                            </button>
                            <span class="btn">{{ obtenerNombreMes(mesActual.getMonth()) | uppercase
                                }}</span>
                            <button class="btn" (click)="cambiarMes(1)">
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-4 pt-3">
                        <div class="input-group">
                            <span class="input-group-text"><i class="fa-solid fa-filter"></i></span>
                            <select class="form-select form-control" formControlName="stores_id">
                                <option [value]="0" ß>TODAS</option>
                                <option *ngFor="let item of stores" [value]="item?.id">{{item?.name | uppercase}}
                                </option>
                            </select>
                            <button (click)="get()" class="btn btn-secondary">
                                <i class="fa-solid fa-search"></i>
                            </button>
                            <button type="button" class="btn btn-success" (click)="generateReport(mdlReport)">
                                <i class="fa-solid fa-file-excel"></i></button>
                        </div>

                    </div>

                </div>
            </form>
        </div>

                </div>
                <div class="card-body">
                    <app-toolbar-search [placeholder]="'Escriba nombre o RUT'" [hideFilter]="true"  class="float-left" (onEmptyInput)="clean()"  (onSearch)="search($event)"/>
                    <ngb-pagination [maxSize]="10"  [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                        <div class="table-responsive">
                            <table class="table user-list">
                                <thead>
                                    <tr>
                                        <th><span>FOLIO</span></th>
                                        <th><span>NOMBRE</span></th>
                                        <th><span>RUT</span></th>
                                        <th><span>VEHÍCULO</span></th>
                                        <th><span>INSTALACIÓN</span></th>
                                        <th><span>DEPENDENCIA</span></th>
                                        <th><span>INGRESO</span></th>
                                        <th><span>SALIDA</span></th>
                                        <th><span>DISPOSITIVO</span></th>
                                        <th><span>GUARDIA</span></th>
                                        <th><span>AUTORIZA</span></th>
                                        <th><span>OBSERVACIÓN</span></th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="items?.length>0; else noData">
                                    <tr *ngFor="let item of items">
                                        <td>
                                            <span>{{item.id}}</span>
                                        </td>
                                        <td>
                                            <span>{{item.name | uppercase}} {{item.lastname | uppercase}}</span><br>
                                            <small class="badge bg-info" *ngIf="item?.access_type">Acceso {{item.access_type | titlecase}}</small>
                                        </td>
                                        <td>
                                            <span>{{item.rut | uppercase}}</span>
                                        </td>
                                        <td>
                                            <span class="badge bg-secondary" *ngIf="item?.access_type === 'Peatonal'">Peatonal</span>
                                            <ng-container *ngIf="item?.access_type !== 'Peatonal'">
                                                <span *ngIf="item?.cars_ppu">
                                                    {{item.cars_ppu | uppercase}}
                                                    <br>
                                                    <small *ngIf="item?.cars_type?.tag">{{item.cars_type.tag | uppercase}}</small>
                                                </span>
                                                <span class="badge bg-warning" *ngIf="!item?.cars_ppu">No registra</span>
                                            </ng-container>
                                        </td>
                                        <td>
                                            <span>{{item?.facility?.name| uppercase}}</span>
                                        </td>
                                        <td>
                                            <span>{{item?.stores?.name| uppercase}}</span>
                                        </td>
                                        <td>
                                            <span>{{item?.date_ing | date:'d/MM/y, h:mm a' }}</span>
                                        </td>
                                        <td>
                                            <span>{{item.date_out | date:'d/MM/y, h:mm a'}}</span>
                                            <span class="badge bg-warning" *ngIf="!item?.date_out">No registrada</span>
                                        </td>
                                        <td>
                                            <span>ID: {{item?.devices.identification}}</span>
                                        </td>
                                        <td>
                                            <span>{{item?.guards?.name| uppercase}} &nbsp; {{item?.guards?.lastname|
                                                uppercase}} <span class="badge ms-1" *ngIf="item?.guards?.position_name" [style.background]="item?.guards.position_color || '#6c757d'">{{ item?.guards.position_name | uppercase }}</span></span>
                                        </td>
                                        <td>
                                            <span>{{item?.authorized}}</span>
                                        </td>
                                        <td>
                                            <span>{{item?.obs}}</span>
                                        </td>
                                    </tr>
    
                                </tbody>
                                <ng-template #noData>
                                    <tbody>
                                        <td colspan="7" class="fw-lighter text-muted">No se encontraron Registros</td>
                                    </tbody>
                                </ng-template>
                            </table>
                        </div>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #noId>
    No se ha recibido el identificador de la instalación
</ng-template>

<ng-template #mdlReport let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">
                <i class="fas fa-spinner fa-spin mr-2" *ngIf="loading"></i>{{loading?"Generando reporte...":"Descargar
                Reporte"}}
            </h5>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="loading">
                <p>Cargando...</p>
            </div>
            <div *ngIf="!loading">
                <a [href]="pathDownload" [download]="pathDownload" target="_blank" class="btn btn-success">
                    <i class="fas fa-download mr-2"></i>Descargar archivo
                </a>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-warning" (click)="d('Cross click')">Cerrar</button>
        </div>
    </div>
</ng-template>
